export const SHOTS_METRIC_KEY = "Shots";
export const SHOTS_ON_TARGET_METRIC_KEY = "Shots on target";
export const SHOTS_ON_TARGET_PERCENT_METRIC_KEY = "Shots on target, %";
export const WIDE_SHOT_METRIC_KEY = "Wide shot";
export const BLOCKED_SHOT_METRIC_KEY = "Blocked shot";
export const SHOT_INTO_BAR_POST_METRIC_KEY = "Shot into the bar/post";

export const SHOTS_COMPONENT_KEYS = [
  SHOTS_ON_TARGET_METRIC_KEY,
  WIDE_SHOT_METRIC_KEY,
  BLOCKED_SHOT_METRIC_KEY,
  SHOT_INTO_BAR_POST_METRIC_KEY,
];

export const toFiniteMetricNumber = (value: unknown) => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : 0;
};

export const getDerivedShots = (stats: Record<string, unknown> | undefined) =>
  SHOTS_COMPONENT_KEYS.reduce((total, metricKey) => {
    return total + toFiniteMetricNumber(stats?.[metricKey]);
  }, 0);

export const getResolvedShots = (stats: Record<string, unknown> | undefined) => {
  const derivedShots = getDerivedShots(stats);
  const rawShotsValue = Number(stats?.[SHOTS_METRIC_KEY]);

  // Sparse feeds can omit split-shot metrics while still providing raw Shots.
  if (derivedShots === 0 && Number.isFinite(rawShotsValue)) {
    return rawShotsValue;
  }

  return derivedShots;
};

export const getShotsOnTargetPercentage = (
  stats: Record<string, unknown> | undefined
) => {
  const totalShots = getResolvedShots(stats);
  if (totalShots === 0) {
    return 0;
  }

  const shotsOnTarget = toFiniteMetricNumber(stats?.[SHOTS_ON_TARGET_METRIC_KEY]);
  return Math.round((shotsOnTarget / totalShots) * 100);
};
